import api from "../api.js";

/**
 * Keycafe integration service
 *
 * Enables passthrough interactions with the Keycafe API via HOPS.
 *
 * @package HOPS
 * @subpackage Integrations
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class KeycafeService {

	/**
	 * Get all the Keycafe keys at the authenticated user's organisation.
	 *
	 * @return {Promise}
	 */
	static getKeys() {
		return api.call({url: `/api/integrations/keycafe/keys`}).then(({data}) => data);
	}


	/**
	 * Known Key Access Record action codes
	 *
	 * @type {Object}
	 */
	static KeyAccessRecordAction = {

		/** Record to be/created on Keycafe */
		Create: 1,

		/** Record to be/deleted on Keycafe */
		Delete: 2

	};


	/**
	 * Known Key Access Record action status codes
	 *
	 * @type {Object}
	 */
	static KeyAccessRecordActionStatus = {

		/** Action submitted to the Keycafe API successfully */
		Complete: 1,

		/** Pending submission to the Keycafe API */
		Pending: 2,

		/** Error submitting to the Keycafe API */
		Error: 3

	};

}

export default KeycafeService;
